import React from 'react';
import styled from 'styled-components';
import COLORS from 'utils/constants/COLORS';

const BaseButton = styled.button`
  border: none;
  outline: none;
  width: 100%;
  color: ${(props) => props.textColor || COLORS.primary};
  background-color: ${(props) => props.bgColor || 'white'};
  height: 60px;
  font-size: 20px;
  text-transform: uppercase;
  cursor: pointer;
  font-family: 'Futura-Medium';
  &:disabled
  {
    background-color:#616c97;
  }
`;
const BaseButtonAtras = styled.button`
  border: none;
  outline: none;
  width: 100%;
  color: ${(props) => props.textColor || COLORS.primary};
  background-color: ${(props) => props.bgColor || 'white'};
  height: 60px;
  font-size: 20px;
  text-transform: uppercase;
  cursor: pointer;
  font-family: 'Futura-Medium';
  border:1px solid #001871
`;
const cotizacionFooterBar = ({
  onClickGuardar,
  showAtras = true,
  onClickAtras,
  onClickContinuar,
  disabledContinue= false
}) => {
  return (
    <span className="p-buttonset" style={{ width: '100%' }}>      
      <div className="row justify-content-center">
        {(showAtras) && <div className="col-12 col-md-3 my-auto bg-white py-2">
          < BaseButtonAtras
            onClick={onClickAtras}
            type="button"
            textColor="#001871"
            bgColor={'white'}
          >
            <i className="pi pi-arrow-left" style={{ position: "relative", top: "1px", fontSize: "1.4rem" }} /> Atrás
          </BaseButtonAtras>
        </div>
        }

        <div
          className="col-12 col-md-3 my-auto bg-white py-2"
        >
          <BaseButton
            type="button"
            textColor="white"
            bgColor={COLORS.primary}
            onClick={onClickGuardar}>
            <i className="pi pi-save" style={{ position: "relative", top: "2px", fontSize: "1.4rem" }} /> GUARDAR
          </BaseButton>
        </div>

        <div className="col-12 col-md-3 my-auto py-2">
          <BaseButton
            textColor="white"
            bgColor={COLORS.primary}
            onClick={onClickContinuar}
            disabled={disabledContinue}
          >
            Continuar <i className="pi pi-arrow-right" style={{ position: "relative", top: "1px", fontSize: "1.4rem" }} />
          </BaseButton>
        </div>
      </div>
    </span >
  );
};

export default cotizacionFooterBar;